export default __webpack_public_path__ + "static/1-8a9ac1add940094dd756e1592aedb55a.png";